import React from 'react'
import type { AccordionDetailsProps } from '@material-ui/core'
import { withStyles, createStyles, AccordionDetails } from '@material-ui/core'

export const styles = createStyles({
  root: {
    padding: 0
  }
})

export interface ExpansionPanelDetailsProps extends Omit<AccordionDetailsProps, 'classes'> {}

function ExpansionPanelDetails(props: ExpansionPanelDetailsProps) {
  return <AccordionDetails {...props} />
}

export default withStyles(styles)(ExpansionPanelDetails)
